// Shown when a CRM request FAILS, in place of the empty state and the zero
// KPIs. An outage must never read as "you have 0 contacts" (UX-038).
import { AlertTriangle, RefreshCw } from 'lucide-react'

interface CrmLoadErrorProps {
  /** What failed to load, in plain words: "your contacts". */
  what: string
  onRetry: () => void
}

export default function CrmLoadError({ what, onRetry }: CrmLoadErrorProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center rounded-2xl border border-red-200 bg-red-50/60 px-6 py-10 text-center"
    >
      <AlertTriangle size={28} className="mb-3 text-red-500" aria-hidden="true" />
      <p className="text-sm font-semibold text-gray-900">Couldn't load {what}</p>
      <p className="mt-1 max-w-md text-sm text-gray-600">
        This is a loading problem, not an empty list. Nothing has been lost. Try again in a moment.
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-4 inline-flex items-center gap-2 rounded-lg bg-sky-500 px-4 py-2 text-sm font-medium text-white hover:bg-sky-600"
      >
        <RefreshCw size={14} aria-hidden="true" /> Retry
      </button>
    </div>
  )
}
